module.exports = __webpack_public_path__ + "img/1.a5aa4468.png";